 

<template>
    <div > 
        <!-- 用于日历功能 -->
        <el-row :gutter="25">
            <el-col :span="24" >
                <!-- <div class="grid-content bg-purple-dark"></div> -->
                <!-- <div  v-for="(item,index) of imgList"  v-bind:key="index"> -->
                <el-col :span="6"   v-for="(item,index) of imgList"  v-bind:key="index" style="height: 120px" > 
                    <!-- <img :src="item.url_mini" alt="" class="imgs"> -->
                    <el-image 
                        class="imgs"
                        fit='scale-down'
                        :src="item.url_mini" 
                        :preview-src-list="srcList"> 
                           <div slot="error"  >
                                <!-- <i class="el-icon-picture-outline"></i> -->
                            </div>

                    </el-image>

                </el-col>


                <!-- </div> -->
            
            
            
            </el-col>



        </el-row>
        




    </div>

</template>

<script>
    export default {
		name:'img_list',
		props: {
            imgList:Array,
    
		},
		methods: {
			// handleSizeChange(val) {
			// 	console.log('每页 ${val} 条');
			// },
		 
		},
		data() {
			return {
                srcList:[]
                // data: {},
                // dialogVisible:false,
                // caldata:{}
                
			};
        },
        mounted() {
            console.log('mounted this.imgList:',this.imgList)
            // let arr=[]
            // for (let p of this.imgList){
            //     arr.push(p.url)
            // }
          
            // this.srcList=arr 
           
           
           // console.log(this.srcList)
     



        },
        watch:{
        
            imgList(){
                console.log('count 发生了变化');
                let arr=[]
                for (let p of this.imgList){
                    arr.push(p.url)
                }
            
                this.srcList=arr 
            }
        }
	}



</script>

<style scoped>
    .imgs{
        height: 90%;
        margin-top: auto;
        width: auto;
    }
 

 
</style>
